var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('Appbar'),_c('v-divider'),_c('router-view'),_c('BottomNavigation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }